import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "PhotoPlaceholder",
  "use": "PhotoPlaceholder-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"PhotoPlaceholder\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-2-2h20v20H-2z\" /><path d=\"M15.5 13.833V2.167C15.5 1.25 14.75.5 13.833.5H2.167C1.25.5.5 1.25.5 2.167v11.666c0 .917.75 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.667zM5.083 9.25l2.084 2.508L10.083 8l3.75 5H2.167l2.916-3.75z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol